import {clearPhone} from '@/services/string';
import BaseService from '@/services/base_service';

export default class ClientService extends BaseService {
  async search(params) {
    try {
      return await axios.get('/clientes/pesquisar', params);
    } catch (e) {
      throw e;
    }
  }
  
   list(params) {
      return new Promise((resolve, reject) => {
         axios.get('/clientes', params).then(response => {
            resolve(response);
         }).catch(e => {
            reject(e);
         });
      });
   }
   get(id) {
      return new Promise((resolve, reject) => {
         axios.get('/clientes/' + id).then(response => {
            resolve(response);
         }).catch(e => {
            reject(e);
         });
      });
   }
   create(model) {
      return new Promise((resolve, reject) => {
         var user = _.clone(model);
         user.telefone = clearPhone(user.telefone);

         axios.post('/clientes', user).then(response => {
            resolve(response);
         }).catch(e => {
            reject(this.getErrors(e));
         });
      });
   }
   update(model) {
      return new Promise((resolve, reject) => {
         var user = _.clone(model);
         user.telefone = clearPhone(user.telefone);

         axios.put('/clientes/' + user.id, user).then(response => {
            resolve(response);
         }).catch(e => {
            reject(this.getErrors(e));
         });
      });
   }
   delete(id) {
      return new Promise((resolve, reject) => {
         axios.delete('/clientes/' + id).then(response => {
            resolve(response);
         }).catch(e => {
            reject(e);
         });
      });
   }
}



// WEBPACK FOOTER //
// ./src/services/client.js